import { Component, OnInit } from '@angular/core';
import { NavService, Menu } from '../../../../services/nav.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'src/app/utils/local-storage.service';
import constant from 'src/app/app.constant';

@Component({
  selector: 'app-mega-menu',
  templateUrl: './mega-menu.component.html',
  styleUrls: ['./mega-menu.component.scss']
})
export class MegaMenuComponent implements OnInit {

  public megaItems: Menu[];
  public levelmenuitems: Menu[];
  public headerItems: Menu[];
  public trackJson: any;
  constructor(public navServices: NavService, public router: Router, private localData: LocalStorageService) {
    this.navServices.megaItems.subscribe(megaItems => this.megaItems = megaItems);
    this.navServices.levelmenuitems.subscribe(levelmenuitems => this.levelmenuitems = levelmenuitems);
    this.navServices.headerItems.subscribe(headerItems => this.headerItems = headerItems);
    setTimeout(async () => {
      this.headerItems = [...this.headerItems]
    }, 1500);
  }

  ngOnInit() {

  }

  megaMenuToggle() {
    this.navServices.levelMenu = false;
    this.navServices.megaMenu = !this.navServices.megaMenu;
    if (window.innerWidth < 991) {
      this.navServices.collapseSidebar = true;
    }
  }

  levelMenuToggle() {
    if (this.localData.getItem(constant.localStorage.user_role_id) == constant.RoleId.vendor) {
      this.router.navigate(['/orders/vendororder']);
    } else {
      this.router.navigate(['/orders/add']);
    }
    // this.navServices.megaMenu  = false;
    // this.navServices.levelMenu = !this.navServices.levelMenu;
    // if(window.innerWidth < 991) { 
    //   this.navServices.collapseSidebar = true;
    // }
  }
  trackorder() {
    this.router.navigate(['/orders/ordertracking']);
  }

  // Click Toggle menu
  toggletNavActive(item) {
    if (!item.active) {
      this.megaItems.forEach(a => {
        if (this.megaItems.includes(item)) {
          a.active = false;
        }
        if (!a.children) { return false; }
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  }


}
